/**
 * Menus API service (assistant, week entries, weekly summary)
 */

import { apiClient } from './client';
import type {
  AssistantQuery,
  AssistantResult,
  WeekMenuResponse,
  WeekSummary,
  MenuEntryView,
  SetMenuEntryRequest,
} from '@/types/api';

export async function getAssistant(
  query: AssistantQuery,
): Promise<AssistantResult> {
  const response = await apiClient.get<AssistantResult>('/menus/assistant', {
    params: query,
  });
  return response.data;
}

export async function getWeekMenu(
  weekStart: string,
): Promise<WeekMenuResponse> {
  const response = await apiClient.get<WeekMenuResponse>('/menus', {
    params: { weekStart },
  });
  return response.data;
}

export async function setMenuEntry(
  data: SetMenuEntryRequest,
): Promise<MenuEntryView> {
  const response = await apiClient.put<MenuEntryView>('/menus', data);
  return response.data;
}

export async function removeMenuEntry(
  date: string,
  mealType: 'lunch' | 'dinner',
): Promise<void> {
  await apiClient.delete('/menus', { params: { date, mealType } });
}

export async function getWeekSummary(
  weekStart: string,
): Promise<WeekSummary> {
  const response = await apiClient.get<WeekSummary>('/menus/week-summary', {
    params: { weekStart },
  });
  return response.data;
}
